import WebApp from '@twa-dev/sdk';

// 初始化Telegram WebApp
export const initTelegram = () => {
  WebApp.ready();
  WebApp.expand();

  // 设置主题参数
  WebApp.setHeaderColor('#2481cc');
  WebApp.setBackgroundColor('#ffffff');

  return WebApp;
};

// 获取用户信息
export const getTelegramUser = () => {
  return WebApp.initDataUnsafe?.user;
};

// 获取用户ID
export const getTelegramUserId = () => {
  return WebApp.initDataUnsafe?.user?.id;
};

// 显示主按钮
export const showMainButton = (text: string, onClick: () => void) => {
  WebApp.MainButton.setText(text);
  WebApp.MainButton.onClick(onClick);
  WebApp.MainButton.show();
};

// 隐藏主按钮
export const hideMainButton = () => {
  WebApp.MainButton.hide();
};

// 显示返回按钮
export const showBackButton = (onClick: () => void) => {
  WebApp.BackButton.onClick(onClick);
  WebApp.BackButton.show();
};

// 隐藏返回按钮
export const hideBackButton = () => {
  WebApp.BackButton.hide();
};

// 显示提示
export const showAlert = (message: string) => {
  WebApp.showAlert(message);
};

// 显示确认对话框
export const showConfirm = (message: string, callback: (confirmed: boolean) => void) => {
  WebApp.showConfirm(message, callback);
};

export default WebApp;
